<!--
 * @Author: qinmengyuan
 * @Date: 2024-06-20 17:13:56
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-06-24 15:22:30
 * @FilePath: \onetab\src\components\SearchComp.vue
-->
<template>
  <div class="search-cont" v-loading="loading">
    <div class="title" v-if="widgetList.length">小组件</div>
    <div class="list">
      <div
        class="item"
        v-for="item in widgetList"
        :key="item.id"
        @click="handleComp(item)"
      >
        <div class="icon" :style="{ background: `url(${item.logo})` }"></div>
        <div class="detail">
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.name }}</div>
        </div>
        <div class="before">
          <RaIcon icon="Plus" />
        </div>
      </div>
    </div>
    <div class="title" v-if="markList.length">快捷方式</div>
    <div class="icons-list">
      <div
        @click="handleComp(item)"
        class="item"
        v-for="item in markList"
        :key="item.id"
        :style="{ background: `url(${item.logo})` }"
      >
        <div class="name">{{ item.name }}</div>
        <div class="before">
          <RaIcon icon="Plus" />
        </div>
      </div>
    </div>
    <!-- <div v-if="!widgetList.length && !markList.length" class="empty">
      <i class="iconfont icon-onetabsousuoshibai"></i>
      <div class="text">暂无数据</div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose, watch } from 'vue';
import { RaIcon } from '@rafter/icon';
import { addBookmark, getSearchIcons } from '@/api/baseApi';
import { bookmarks } from '@/store/bookmarks';
import { RaMessage } from '@rafter/pc';
const props = defineProps({
  searchKey: {
    type: String,
    default: '',
  },
});
const widgetList = ref([]);
const markList = ref([]);
const loading = ref(false);
const checked = ref({});
const throttle = (func, wait) => {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    if (!timer) {
      timer = setTimeout(function () {
        timer = null;
        func.apply(context, args);
      }, wait);
    }
  };
};
const handleComp = (item) => {
  checked.value = item;
  window['_paq'].push(['trackEvent', '书签', '常用新增', checked.value.url, 1]);
  addBookmark({
    type: checked.value.type_id > 14 ? 3 : 1,
    name: checked.value.name,
    url: checked.value.url,
    category_uuid: bookmarks.getActive()?.uuid,
    icon: checked.value.logo,
    order: bookmarks.getActive()?.bookmarks.length + 1,
    describe: checked.value.describe ?? '',
  })
    .then((res) => {
      RaMessage({
        type: 'success',
        message: '添加成功',
      });

      bookmarks.addOneToActive(res);
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
    });
};

const getSearchList = () => {
  loading.value = true;
  getSearchIcons({ name: props.searchKey, page: 1, size: 28 })
    .then((res) => {
      if (res.data.code === 200) {
        widgetList.value = res.data?.data?.widgets || [];
        markList.value = res.data?.data?.icons || [];
      }
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
    })
    .finally(() => {
      loading.value = false;
    });
};
defineExpose({
  getSearchList,
});
</script>
<style lang="scss" scoped>
::v-deep(.ra-loading-mask) {
  background-color: transparent;
}
.empty {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  .iconfont {
    font-size: 90px;
    @include font_color('text-on-surface-primary');
  }
  .text {
    @include font_color('text-on-surface-primary');
  }
}
.search-cont {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  overflow: auto;
  padding: 5px;
  margin: -5px;

  .title {
    color: var(--Text-on-surface-tertiary, #787f8f);
    font-family: 'PingFang SC';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    border-bottom: 1px solid var(--border-default, rgba(26, 26, 26, 0.05));
  }
  &::-webkit-scrollbar {
    display: none;
  }

  /* 隐藏滚动条轨道 */
  &::-webkit-scrollbar-track {
    display: none;
  }

  /* 隐藏滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  .list {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    .item {
      display: flex;
      width: 260px;
      padding: var(--spacing-8, 16px) 20px;
      align-items: center;
      gap: var(--spacing-8, 16px);
      border-radius: 16px;
      background: var(--background-on-background, rgba(250, 250, 250, 0.9));
      position: relative;
      .before {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-10%, -10%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background-color: #2cd142;
        opacity: 0;
        color: rgba(255, 255, 255, 0.9);
      }
      &:hover {
        .before {
          opacity: 1;
        }
      }
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 8.75px;
        background: #283567;
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-size: cover !important;
        flex-shrink: 0;
      }
      .detail {
        display: flex;
        flex-direction: column;
        gap: 4px;
        .name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 200px;
        }
        .desc {
          color: var(--Text-on-surface-tertiary, #787f8f);
          text-align: justify;
          font-family: 'PingFang SC';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px; /* 133.333% */
        }
      }
    }
  }
  .icons-list {
    display: flex;
    gap: 54px;
    flex-wrap: wrap;
    .item {
      position: relative;
      width: 72px;
      height: 72px;
      border-radius: 20px;
      cursor: pointer;
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-size: contain !important;
      .name {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        text-overflow: ellipsis;
        @include font_color('text-on-surface-primary');
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
        letter-spacing: 0.4px;
        bottom: -24px;
        max-width: 100%;
        overflow: hidden;
      }
      .before {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(-10%, -10%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background-color: #2cd142;
        opacity: 0;
        color: rgba(255, 255, 255, 0.9);
      }
      &:hover {
        .before {
          opacity: 1;
        }
      }
    }
  }
}
</style>
